(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    var countdown = document.getElementById('rs-countdown');
    if (!countdown) return;

    // TODO: Set your real launch date & time here.
    // Example below: 2025-11-24 at 10:00 (local browser time)
    var launchDate = new Date(2025, 10, 24, 21, 0, 0).getTime();
    //            year, month(0-based), day, hour, min, sec

    var daysEl = document.getElementById('rs-days');
    var hoursEl = document.getElementById('rs-hours');
    var minutesEl = document.getElementById('rs-minutes');
    var secondsEl = document.getElementById('rs-seconds');

    function pad(num) {
      return num < 10 ? '0' + num : String(num);
    }

    function updateCountdown() {
      var now = new Date().getTime();
      var distance = launchDate - now;

      if (distance <= 0) {
        countdown.innerHTML = '<span style="font-size:0.9rem;">¡Ya hemos lanzado!</span>';
        clearInterval(interval);
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    var interval = setInterval(updateCountdown, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  const link = e.target.closest('.rs-col-card');
  if(!link) return;

  // create ripple
  const rect = link.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const ripple = document.createElement('span');
  ripple.className = 'rs-ripple';
  ripple.style.width = ripple.style.height = size + 'px';
  ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
  ripple.style.top  = (e.clientY - rect.top  - size/2) + 'px';
  link.appendChild(ripple);
  setTimeout(()=> ripple.remove(), 520);

  // small delay so the ripple is visible, then navigate
  e.preventDefault();
  setTimeout(()=>{ window.location.href = link.href; }, 160);
}, {capture:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collections-card"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  const link = e.target.closest('.rs-col-card');
  if(!link) return;

  // create ripple
  const rect = link.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const ripple = document.createElement('span');
  ripple.className = 'rs-ripple';
  ripple.style.width = ripple.style.height = size + 'px';
  ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
  ripple.style.top  = (e.clientY - rect.top  - size/2) + 'px';
  link.appendChild(ripple);
  setTimeout(()=> ripple.remove(), 520);

  // small delay so the ripple is visible, then navigate
  e.preventDefault();
  setTimeout(()=>{ window.location.href = link.href; }, 160);
}, {capture:true});

  } catch(e) { console.error(e); }
})();
})();
